import React from 'react';
import Flex from '../Flex/Flex';
import SelectionButton, { SelectionButtonProps } from './SelectionButton';
import styles from './SelectionButtonGroup.module.scss';
import { CreateProps } from '../../types/utils/CreateProps';

type SelectionButtonGroupProps = CreateProps<
  {
    /** How many SelectionButtons should be shown side by side in one row */
    sideBySide?: number;
    /**  List of SelectionButton contents */
    options: SelectionButtonProps[];
    /** onClick handler for the group. Returns the event and clicked option */
    onClick: (
      event: React.SyntheticEvent<HTMLButtonElement, Event>,
      option: SelectionButtonProps
    ) => void;
    /** Enables smaller height variant of the SelectionButtons */
    narrow?: boolean;
    /** Variant with dropshadow. Disabled options don't show the shadow */
    withShadow?: boolean;
  },
  typeof Flex,
  'wrapContent'
>;

const SelectionButtonGroup: React.FunctionComponent<SelectionButtonGroupProps> = ({
  options,
  sideBySide = options.length,
  narrow,
  withShadow,
  onClick,
  ...props
}) => {
  const handleOnClick = (
    event: React.SyntheticEvent<HTMLButtonElement, Event>,
    id: string
  ) => {
    const clickedOption = options.find((option) => option.id === id);
    onClick(event, clickedOption as SelectionButtonProps);
  };

  return (
    <Flex wrapContent className={styles.selectionButtonGroup} {...props}>
      {options.map((option, index) => {
        const amountOfMargins = sideBySide;
        const classNames = [styles.selectionButtonGroup_button];
        option.className && classNames.push(option.className as string);

        const { children, ...optionProps } = option;

        return (
          <SelectionButton
            {...optionProps}
            key={index}
            className={classNames}
            narrow={narrow}
            style={{
              width: `calc((100% - ${amountOfMargins} * 8px)/${sideBySide})`,
            }}
            onClick={handleOnClick}
            withShadow={withShadow}
          >
            {children}
          </SelectionButton>
        );
      })}
    </Flex>
  );
};

export default SelectionButtonGroup;
